export default __webpack_public_path__ + "static/media/logo2.6e5c9b07.png";